import Modal from "src/components/Modal/Modal";
import { Box, Text, Image, Button } from "@chakra-ui/react";
import { H3 } from "src/atoms/typography";
import { Trans, useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getAppValue } from "src/utils/environment";
import getImageSrc from "src/utils/getImageSrc";
import { ReactComponent as Voice } from "./Monitors/icons/voice.svg";
import { ReactComponent as Camera } from "./Monitors/icons/camera.svg";
import { ReactComponent as Hamburger } from "./Monitors/icons/hamburger.svg";
import { ReactComponent as Microphone } from "src/modules/parent-station/components/ControlButtons/PttButton/microphone.svg";
import { sawMonitoringHelp } from "src/duck/actions";
import { getHasSeenMonitoringHelp } from "src/duck/selectors";
import SvgContainer from "src/components/SvgContainer";
import NoteContainer from "src/components/NoteContainer";

export default function MonitoringHelp() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const hasSeenMonitoringHelp = useSelector(getHasSeenMonitoringHelp);

  if (hasSeenMonitoringHelp) return null;

  return (
    <Modal isOpen contentProps={{ w: "400px" }}>
      <Box textAlign="center" p="32px" borderRadius="12px">
        <H3>{t("parent.welcome.title")}</H3>
        <Text fontSize="12px" fontWeight={400} lineHeight="20px" letterSpacing={0.15} my="8px" color="mediumEmphasis">
          <Trans
            i18nKey="parent.welcome.message"
            components={{
              1: (
                <SvgContainer
                  as="span"
                  display="inline-block"
                  verticalAlign="text-bottom"
                  icon={Camera}
                  fill="mediumEmphasis"
                />
              ),
              2: (
                <SvgContainer
                  as="span"
                  display="inline-block"
                  verticalAlign="text-bottom"
                  size="16px"
                  icon={getAppValue({ barkio: Voice, bibino: Microphone })}
                  fill="mediumEmphasis"
                />
              )
            }}
          />
        </Text>
        <Image mx="auto" width="198px" height="144px" src={getImageSrc("ps-help.svg")} />
        <NoteContainer>
          <Trans
            i18nKey="parent.welcome.note"
            components={{
              b: <b />,
              1: (
                <SvgContainer
                  as="span"
                  display="inline-block"
                  verticalAlign="text-bottom"
                  size="16px"
                  icon={Hamburger}
                  fill="mediumEmphasis"
                />
              )
            }}
          />
        </NoteContainer>
        <Button onClick={() => dispatch(sawMonitoringHelp())} mt="16px">
          {t("buttons.gotIt")}
        </Button>
      </Box>
    </Modal>
  );
}
